<script setup>
import { router, Head, Link, useForm } from '@inertiajs/vue3';
import JetApplicationHeader from '@/Jetstream/ApplicationHeader.vue';
import JetApplicationFooter from '@/Jetstream/ApplicationFooter.vue';
import JetWelcomePanel from '@/Jetstream/WelcomePanel.vue';

defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    // programme: Object,
    // organisation: Object,
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

</script>

<template>
    <Head title="Programme" />

    <JetApplicationHeader />

    <div id="content-wrapper">

        <div id="main-content" class="container mx-auto flex flex-col md:flex-row justify-between w-full pt-5 pb-5">

            <div id="col-intro" class="md:w-3/3 md:pr-10 lg:pr-40">
                <JetWelcomePanel :programme="programme" :organisation="organisation" />
            </div>
        </div>

    </div>

    <JetApplicationFooter :programme="programme" :organisation="organisation" />


</template>
